<div class="case-study-page" [@leave] [@enter]>
    <app-banner></app-banner>
    <app-grids></app-grids>
    <app-targeted-strategies [componentData] = dataList[0]></app-targeted-strategies>
    <app-targeted-strategies [componentData] = dataList[1]></app-targeted-strategies>
    <app-color-grid></app-color-grid>
    <app-targeted-strategies [componentData] = dataList[2]></app-targeted-strategies>
    <app-stories></app-stories>
</div>